export enum RecordingState {
  OFF = "OFF",
  RECORDING = "RECORDING",
  PAUSED = "PAUSED",
}
